import InView from 'react-intersection-observer';
import { motion } from 'framer-motion';
import React from 'react';

export const Video = () => {
  return (
    <InView triggerOnce={false}>
      {({ ref, inView }) => (
        <motion.video
          ref={ref}
          src="https://firebasestorage.googleapis.com/v0/b/website-orqafpv.firebasestorage.app/o/dreamX.mp4?alt=media&token=ff0212c5-e8b7-47b7-8f34-8aeb7531547a"
          className="fpvpilot__video dreamX__video"
          initial={{ opacity: 0.6, width: '70%' }}
          animate={{
            opacity: inView ? 1 : 0.6,
            width: inView ? '100%' : '70%',
          }}
          transition={{ ease: 'easeOut', duration: 0.6, delay: 0.3 }}
          muted
          autoPlay
          loop
          playsInline
        />
      )}
    </InView>
  );
};
